import { RULES } from "../../data/constans";
import { motion, Variants } from "framer-motion";

const KnowHow = () => {
  const containerVertical = (startingPosition: number, delay: number): Variants => ({
    initial: { y: startingPosition, opacity: 0 },
    whileInView: { y: 0, opacity: 1, transition: { duration: 0.5, delay: delay } },
  });
  const containerHorizontal = (startingPosition: number, delay: number): Variants => ({
    initial: { x: startingPosition, opacity: 0 },
    whileInView: { x: 0, opacity: 1, transition: { duration: 0.5, delay: delay } },
  });
  return (
    <div
      id="knowhow"
      className="flex scroll-mt-[8vh] justify-center bg-gradient-to-r from-blue-300 to-blue-500 md:min-h-[92vh]"
    >
      <div className="flex flex-col items-center justify-center gap-8 py-10 md:w-[50%] md:gap-24 lg:w-[50%] xl:w-[40%]">
        {/* TITLE */}
        <div className="flex flex-col items-center justify-center gap-1">
          <motion.div
            variants={containerHorizontal(-10, 0.5)}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="text-center text-2xl font-extrabold text-white md:text-4xl lg:text-5xl xl:text-6xl"
          >
            {RULES.title1}
          </motion.div>
          <motion.div
            variants={containerHorizontal(10, 1)}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="text-center text-xl font-light text-white md:text-2xl lg:text-3xl xl:text-4xl"
          >
            {RULES.title2}
          </motion.div>
        </div>
        {/* DESCRIPTION */}
        <div className="flex flex-col items-center justify-center gap-4 md:gap-2">
          <ul className="w-[80%] list-disc text-justify text-base font-light text-white md:w-full lg:text-lg">
            {RULES.description.map((desc, idx) => (
              <motion.li
                key={idx}
                variants={containerHorizontal(-10, 1.5 + idx * 0.5)}
                initial="initial"
                whileInView="whileInView"
                viewport={{ once: true }}
                className="mb-2"
              >
                {desc}
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KnowHow;
